<template>
<v-container v-resize="onResize">
   <v-card flat>
     <v-card-text>
      <v-row>
        <v-col cols="4"> <h4 class="font-weight-black"> {{chat.phoneNumber}}</h4></v-col>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="showResolveChatDialog"> Mark as Resolved</v-btn>
      </v-row>
     </v-card-text>
   </v-card>
   <v-card flat :height="windowSize.y - 280" style="overflow-y: auto;background-color: #e5e5db;" id="card">
     <v-card-text>
    <div v-for="message in messages" :key="message.id">
     <v-row v-if="message.direction === 'OUTBOUND'" justify="end" align="end" class="mt-1">
         <sent-message :message="message"></sent-message>
     </v-row>
     <v-row v-else class="mt-1">
         <received-message :message="message"></received-message>
     </v-row>
    </div>
     </v-card-text>
   </v-card>
   <v-card ref="inputarea">
        <v-card-text>
          <v-row align="center" justify="start">
            <v-col cols="8">
              <v-textarea
                prepend-icon="mdi-emoticon"
                append-outer-icon="mdi-send"
                filled
                clear-icon="mdi-close-circle"
                clearable
                label="type your message"
                type="text"
                @click:append-outer="triggerSendMessage"
                v-model="message"
                :loading="loading"
                outlined
                rows="3"
                row-height="15"
                class="inputtext"
                v-on:keyup.ctrl.enter="triggerSendMessage"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
   </v-card>
   <v-dialog v-model="resolvedDialog" max-width="60%">
      <v-card>
        <v-card-title class="headline">Resolve Chat</v-card-title>
        <v-card-text>
          <h4 class="mt-2">Are you sure you want to resolve chat?</h4>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="resolvedDialog = false"
            >Cancel</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="triggerResolveChat">Resolve</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</v-container>
</template>
<script>

import ReceivedMessage from './ReceivedMessageComponent.vue'
import SentMessage from './SentMessageComponent.vue'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    ReceivedMessage,
    SentMessage
  },
  mounted () {
    this.chatId = this.$route.params.id
    this.onResize()
  },
  data: () => ({
    chatId: 0,
    windowSize: {
      x: 0,
      y: 0
    },
    message: '',
    loading: false,
    resolvedDialog: false
  }),
  computed: mapState({
    messages: (state) => state.chat.messages,
    chat: (state) => state.chat.chat
  }),
  watch: {
    messages (newValue, oldValue) {
      console.log(newValue)
      if (newValue === true) {
        setTimeout(() => {
          this.scrollToEnd()
        }, 0)
      }
    }
  },
  methods: {
    ...mapActions({ sendMessage: 'chat/sendMessage', resolveChatBySessionId: 'chat/resolveChatBySessionId' }),
    onResize () {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight }
    },
    scrollToEnd: function () {
      var container = this.$el.querySelector('#card')
      container.scrollTop = container.scrollHeight
    },
    triggerSendMessage () {
      if (this.loading) {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'warning', message: 'Message currently being sent' }, { root: true })
        return
      }
      const message = { chatId: this.chatId, message: this.message }
      this.loading = true
      this.sendMessage(message).then(response => {
        if (!response.data.isError) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'success', message: response.data.message }, { root: true })
          this.message = ''
          this.loading = false
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message }, { root: true })
          this.loading = false
        }
        this.scrollToEnd()
        this.$store.dispatch('chat/getChatMessages', this.$route.params.id)
      }).catch(error => {
        this.loading = false
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    },
    showResolveChatDialog () {
      this.resolvedDialog = true
    },
    triggerResolveChat () {
      this.resolveChatBySessionId(this.$route.params.sessionId).then(response => {
        if (!response.data.isError) {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'success', message: response.data.message }, { root: true })
          this.$store.dispatch('botsession/getContactCustomerCareRecords')
        } else {
          this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: response.data.message }, { root: true })
        }
        this.resolvedDialog = false
        this.$router.push('/contactcenter')
      }).catch(error => {
        this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data.message }, { root: true })
      })
    }
  },
  created () {
    this.$store.dispatch('chat/getChatMessages', this.$route.params.id)
    this.$store.dispatch('chat/getChat', this.$route.params.id)
  }
}
</script>
<style>
</style>
